import {
  RenderTextWithContainerPattern,
  CarePlanTemplateList,
  OrderList,
  ReportSection,
} from "../constant";
import AllergiesBlock from "../_shared/AllergiesBlock";
import HistoryBlock from "../_shared/HistoryBlock";
import MedicationsBlock from "../_shared/MedicationsBlock";
import VitalsBlock from "../_shared/VitalsBlock";
import RosBlock from "../_shared/RosBlock";
import PhysicalExamBlock from "../_shared/PhysicalExamBlock";
import ScreeningAssessmentBlock from "../_shared/ScreeningAssessmentBlock";
import AssessmentBlock from "../_shared/AssessmentBlock";
import PrescriptionsBlock from "../_shared/PrescriptionsBlock";
import VaccinesBlock from "../_shared/VaccinesBlock";
import CptCodesBlock from "../_shared/CptCodesBlock";

interface PrimaryCareSoapNoteTemplateProps {
  data: any;
}

/**
 * PrimaryCareSoapNoteTemplate — PRIMARY_CARE_SOAP_NOTE
 *
 * Sequence strictly follows SOAP structure:
 *   Subjective → Objective → Assessment → Plan → Follow-Up
 */
const PrimaryCareSoapNoteTemplate = ({
  data,
}: PrimaryCareSoapNoteTemplateProps) => {
  return (
    <>
      {/* ── Subjective ── */}
      <ReportSection label="Subjective">
        <RenderTextWithContainerPattern
          label="History of Present Illness"
          val={data?.historyOfPresentIllness}
        />
        <RenderTextWithContainerPattern
          label="Subjective"
          val={data?.subjectiveFreeNote}
        />
        <AllergiesBlock data={data} />
        <HistoryBlock data={data} />
        <RenderTextWithContainerPattern label="Habits" val={data?.habits} />
        <MedicationsBlock data={data} />
      </ReportSection>

      {/* ── Objective ── */}
      <ReportSection label="Objective">
        <RenderTextWithContainerPattern
          label="Objective"
          val={data?.objectiveFreeNote}
        />
        <VitalsBlock data={data} />
        <PhysicalExamBlock data={data} />
        <RosBlock data={data} />
        <ScreeningAssessmentBlock data={data} />
      </ReportSection>

      {/* ── Assessment ── */}
      <ReportSection label="Assessment">
        <AssessmentBlock data={data} />
      </ReportSection>

      {/* ── Plan ── */}
      <ReportSection label="Plan">
        <RenderTextWithContainerPattern label="Plan" val={data?.planFreeNote} />
        <PrescriptionsBlock data={data} />
        <VaccinesBlock data={data} />
        <OrderList orders={data?.patientOrders} />
        <CptCodesBlock data={data} />
        <RenderTextWithContainerPattern
          label="Care Plan"
          val={data?.carePlan}
        />
        <CarePlanTemplateList carePlanTemplates={data?.carePlanTemplates} />
      </ReportSection>

      {/* ── Follow-Up ── */}
      <ReportSection label="Follow-Up">
        <RenderTextWithContainerPattern
          label="Follow Up"
          val={data?.followUp}
        />
        <RenderTextWithContainerPattern
          label="Instructions"
          val={data?.instruction}
        />
      </ReportSection>
    </>
  );
};

export default PrimaryCareSoapNoteTemplate;
